import { Link } from "react-router-dom";
import { categories } from "@/mocks/videoData";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </span>
                <span className="text-lg font-bold text-background-50">苹果视频</span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                免费高清电影电视剧在线观看平台，流畅不卡顿，汇聚海量热门影视资源，随时随地想看就看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-categories" className="hover:text-primary-400 transition-colors">视频分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/movie" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">热门电影</Link>
                </li>
                <li>
                  <Link to="/category/tv" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">热播剧集</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系方式</a>
              </h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-mail-line"></i>
                  <span>service@apple-video.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-wechat-line"></i>
                  <span>AppleVideo_Official</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/60">
                  <i className="ri-phone-line"></i>
                  <span>400-888-0000</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 苹果视频 Apple Video. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}